<template>
  <v-navigation-drawer
    id="app-drawer"
    v-model="inputValue"
    :mobile-break-point="$route.path !== '/dashboard' ? 1265 : 991"
    hide-overlay
    class="alert"
    app
    dark
    floating
    persistent
    absolute
    width="264"
  >
    <v-img
      :src="image"
      :gradient="sidebarOverlayGradiant"
      height="100%"
    >

      <v-layout
        class="fill-height"
        tag="v-list"
        dense
        column
      >
        <a :href="'/'">
          <v-img
            :src="logo"
            :title="descricaoLogoPrincipal"
            :max-height="$vuetify.breakpoint.height >= 695 ? 120 : 60"
            contain
          />
          <v-layout
            v-if="loading || user.consultor || user.gestor || (user.vinculado && user.emp_user.acesso !== 3)"
            column
            justify-center
            align-center
            style="height: 30px!important"
          >
            <v-flex v-if="!loading">
              <v-flex>
                <v-btn
                  :title="strings[idioma].area_do_consultor"
                  :href="'/consultor'"
                  small
                  flat
                  dark
                  @click="linkTo('consultor')"
                >
                  <v-icon>mdi-group</v-icon>&nbsp;
                  {{ strings[idioma].area_do_consultor }}
                </v-btn>
              </v-flex>
            </v-flex>
            <v-progress-circular
              v-else
              :size="35"
              color="white"
              indeterminate />
          </v-layout>
        </a>
        <v-divider/>
        <template v-for="(link, i) in (user.pecuarista) ? links.filter(l => (!l.naoAparecer || !l.naoAparecer.includes('pecuarista')) &&  !l.oculta) : links.filter(l => !l.oculta)">
          <v-list-tile
            :to="link.to"
            :active-class="color"
            :title="link.text[idioma]"
            :style="'height: 35px; font-size: 10px!important;'"
            avatar
            class="v-list-item"
            @click="linkTo(link.to)"
          >
            <v-list-tile-action>
              <v-icon :style="'font-size: 20px!important;'">{{ link.icon }}</v-icon>
            </v-list-tile-action>
            <v-list-tile-title
              v-text="link.text[idioma]"
              :style="'font-size: 12px!important;'"
            />
          </v-list-tile>
        </template>
        <v-list-tile
          :style="'height: 45px!important; align: center;'"
          align-center

          class="v-list-item">
          <v-toolbar-items>
            <v-flex
              align-center
              layout
              py-2>
              <Notificacoes/>
              <v-menu
                open-delay="900"
                open-on-click
                top
                right
                content-class="dropdown-menu"
                offset-y
                transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn
                    :title="strings[idioma].planilhas"
                    icon
                    text
                    dark
                    v-on="on"
                  >
                    <v-icon>mdi-file-excel</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list dense>
                    <v-list-tile
                      v-for="planilha in menus.planilhas"
                      :key="planilha.title[idioma]"
                      :href="'assets/planilhas/'+planilha.action"
                    >
                      <v-list-tile-title
                        v-text="planilha.title[idioma]"
                      />
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
              <v-menu
                open-delay="900"
                open-on-click
                top
                left
                content-class="dropdown-menu"
                offset-y
                transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn
                    :title="strings[idioma].livros"
                    icon
                    text
                    dark
                    v-on="on"
                  >
                    <v-icon>mdi-notebook</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list dense>
                    <v-list-tile
                      v-for="livro in menus.livros"
                      :key="livro.title[idioma]"
                      :href="livro.action"
                      target="brcorte_livro"
                    >
                      <v-list-tile-title
                        v-text="livro.title[idioma]"
                      />
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
              <v-menu
                open-delay="900"
                open-on-click
                top
                left
                content-class="dropdown-menu"
                offset-y
                transition="slide-y-transition">
                <template v-slot:activator="{ on }">
                  <v-btn
                    :title="strings[idioma].instrucoes"
                    icon
                    text
                    dark
                    v-on="on"
                  >
                    <v-icon>mdi-information-outline</v-icon>
                  </v-btn>
                </template>
                <v-card>
                  <v-list dense>
                    <v-list-tile
                      v-for="instrucao in menus.instrucoes"
                      :key="instrucao.title[idioma]"
                      :href="instrucao.action"
                      target="brcorte_instrucao"
                    >
                      <v-list-tile-title
                        v-text="instrucao.title[idioma]"
                      />
                    </v-list-tile>
                  </v-list>
                </v-card>
              </v-menu>
              <v-btn
                icon
                text
                dark
                title="Feedback"
                @click="linkTo('/feedback', true)"
              >
                <v-icon>mdi-message-outline</v-icon>
              </v-btn>
            </v-flex>
          </v-toolbar-items>
        </v-list-tile>
        <core-footer v-show="$vuetify.breakpoint.height >= 700"/>
      </v-layout>

    </v-img>
    
  </v-navigation-drawer>
</template>

<script>
// Utilities
import {
  mapMutations,
  mapState
} from 'vuex'
import Notificacoes from '../../views/components/Notificacoes/Notificacoes'

export default {
  components: {
    Notificacoes
  },
  data: () => ({
    logo: process.env.VUE_APP_LOGO_BRANCA ? process.env.VUE_APP_LOGO_BRANCA : './img/brcorte5-logobranca.png'
    // logo: './img/br-corte-logobranca.png'
  }),
  computed: {
    ...mapState('app', ['menus', 'image', 'color', 'idioma', 'links', 'strings', 'trava_back', 'user', 'empresa', 'loading', 'descricaoLogoPrincipal']),
    inputValue: {
      get () {
        if (this.$route.path === '/dashboard' && this.$vuetify.breakpoint.width > 991) return true
        return this.$store.state.app.drawer
      },
      set (val) {
        this.setDrawer(val)
      }
    },
    items () {
      return this.$t('Layout.View.items')
    },
    sidebarOverlayGradiant () {
      return `${this.$store.state.app.sidebarBackgroundColor}, ${this.$store.state.app.sidebarBackgroundColor}`
    }
  },
  created () {
    this.$store.commit('getLinks')
  },
  methods: {
    ...mapMutations('app', ['setDrawer', 'toggleDrawer']),
    linkTo (to, force = false) {
      if (force) window.location.href = to
      if ((this.$route.path === to || this.$route.path === '/dashboard') && (!this.trava_back || (this.trava_back && confirm(this.strings[this.idioma].msg_sair)))) { window.location.href = to }
    }
  }
}
</script>

<style lang="scss">
  #app-drawer {
    .v-list__tile {
      border-radius: 4px;

      &--buy {
        margin-top: auto;
        margin-bottom: 17px;
      }
    }

    .v-image__image--contain {
      top: 20px;
      max-height: 60%;
    }

    .search-input {
      margin-bottom: 30px !important;
      padding-left: 15px;
      padding-right: 15px;
    }

    div.v-responsive.v-image > div.v-responsive__content {
      overflow-y: auto;
    }
  }
</style>
